<script lang="ts">
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import CopyIconLarge from "@apps/rewards/widgets/rewards_hub_widget/v1/components/icons/MainViewIcons/CopyIconLarge.svelte";

    import RewardsCopyIconButton from "../Buttons/RewardsCopyIconButton.svelte";
    import RewardsIcon from "../RewardsIcon.svelte";
    import RewardsTextField from "./RewardsTextField.svelte";

    //Props
    export let value: string;
    export let namespace: TranslationNamespaces;
    export let ariaLabel: string;
</script>

<div class="gw-rd-copy-field">
    <RewardsTextField {value} readonly>
        <RewardsCopyIconButton slot="suffix" {value} {namespace} {ariaLabel}>
            <RewardsIcon size="fullWidth">
                <CopyIconLarge />
            </RewardsIcon>
        </RewardsCopyIconButton>
    </RewardsTextField>
</div>

<style lang="postcss">
    .gw-rd-copy-field {
        & :global(.gw-rd-text-field) {
            background-color: transparent;

            :global(.gw-rd-text-field__input) {
                opacity: 0.6;
            }

            &:focus-within {
                outline: none;
            }
        }

        & :global(.gw-btn.gw-rd-icon-btn) {
            width: 20px;
            height: 20px;
        }
    }
</style>
